// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".margin-checkbox-label[data-v-b11ee5e6] .custom-control-label{margin-top:2px!important}.custom-v-select-pax-type[data-v-b11ee5e6] .v-select .vs__dropdown-toggle{border:0;-webkit-box-shadow:none;box-shadow:none}", ""]);
// Exports
module.exports = exports;
